import { useMemo, useState } from 'react';
import ReactGA from 'react-ga4';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputContainer } from '../../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { RadioCard } from '../../../../../components/common/Radio/RadioCard';
import { joinProcessConstants } from '../../../../../constants/joinProcess';
import { usePostSignUpMutation } from '../../../../../hooks/api/auth/mutations/usePostSignUp.mutation';
import { useAppSelector } from '../../../../../hooks/store/useStore';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessTractorWantBuyCheckPage = () => {
  const [wantBuyTractorInfo, setWantBuyTractorInfo] = useState<string>();

  const userJoinSelector = useAppSelector((state) => state.userJoin);
  const userRegionSelector = useAppSelector((state) => state.userRegion);

  const { mutate: postSignUp } = usePostSignUpMutation();

  const extraInfoOfJob = useMemo<{ infoType: string; infoValue: string }[]>(() => {
    const extraInfos = [];

    switch (userJoinSelector.job) {
      case '농업 종사자':
        if (userJoinSelector.cropTypes) {
          userJoinSelector.cropTypes
            .split(',')
            .forEach((cropType) => extraInfos.push({ infoType: '재배작물', infoValue: cropType }));
        }
        if (userJoinSelector.cropName) {
          extraInfos.push({ infoType: '재배 종', infoValue: userJoinSelector.cropName });
        }
        break;

      case '농기계 사업 종사자':
        if (userJoinSelector.businessName) {
          extraInfos.push({ infoType: '상호명', infoValue: userJoinSelector.businessName });
        }
        if (userJoinSelector.businessType) {
          extraInfos.push({
            infoType: '사업형태',
            infoValue: userJoinSelector.businessTypeEtc ?? userJoinSelector.businessType,
          });
        }
        break;

      case '일반 회원':
        if (userJoinSelector.detailJob) {
          extraInfos.push({ infoType: '직업', infoValue: userJoinSelector.detailJob });
        }
        break;

      default:
    }

    return extraInfos;
  }, [userJoinSelector]);

  const confirmHandler = () => {
    postSignUp(
      {
        reqBody: {
          signUpToken: sessionStorage.getItem('@signUpToken') ?? '',
          advertisementTermsAgreement: userJoinSelector.advertisementTermsAgreement ?? false,
          marketingTermsAgreement: userJoinSelector.marketingTermsAgreement ?? false,
          latitude: userRegionSelector.userLatitude ?? '',
          longitude: userRegionSelector.userLongitude ?? '',
          residence: {
            regionDepth1: userRegionSelector.userRegionDepth1 ?? '',
            regionDepth2: userRegionSelector.userRegionDepth2 ?? '',
            regionDepth3: userRegionSelector.userRegionDepth3 ?? '',
          },
          job: userJoinSelector.job ?? '',
          extraInfoOfJob,
          joinReason: userJoinSelector.joinReasons ?? '',
          joinReasonEtc: userJoinSelector.joinReasonEtc ?? '',
          ownTractor: userJoinSelector.tractorOwnCheck ?? null,
          purchaseTractorYn: wantBuyTractorInfo ?? null,
        },
      },
      {
        onSuccess: () => {
          ReactGA.event('pvm_sign_up', { category: 'pvm', action: 'pvm_sign_up' });
        },
      },
    );
  };

  return (
    <>
      <JoinProcessPageWrapper headerTitle={'트랙터 구매 의사가 있으신가요?'} canConfirm confirmHandler={confirmHandler}>
        <SurveyForm>
          <SurveyInputHeader inputTitle={'트랙터 구매 의사'} isOptional />

          <SurveyInputContainer gridColumns={1}>
            {joinProcessConstants.tractorWantBuyCheck.values.map((value, index) => (
              <RadioCard
                key={value}
                title={value}
                label={
                  joinProcessConstants.tractorWantBuyCheck.labels &&
                  joinProcessConstants.tractorWantBuyCheck.labels.length > 0
                    ? joinProcessConstants.tractorWantBuyCheck.labels[index]
                    : undefined
                }
                onClick={() => {
                  setWantBuyTractorInfo(value);
                }}
                isActive={wantBuyTractorInfo === value}
              />
            ))}
          </SurveyInputContainer>
        </SurveyForm>
      </JoinProcessPageWrapper>
    </>
  );
};
